<!DOCTYPE html>
<html lang="fa">
<head>
  <meta charset="utf-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1">

  <title>hashtagbime</title>

  <!-- Google font -->
  <link href="https://fonts.googleapis.com/css?family=Fredoka+One" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css?family=Raleway:400,700" rel="stylesheet">

  <!--[if lt IE 9]>
  <script src="https://oss.maxcdn.com/html5shiv/3.7.3/html5shiv.min.js"></script>
  <script src="https://oss.maxcdn.com/respond/1.4.2/respond.min.js"></script>
  <![endif]-->
</head>
<body>
<app-main-nav-bar></app-main-nav-bar>
<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h1>404</h1>
    </div>
    <h2>صفحه مورد نظر یافت نشد!
    </h2>
    <br>
    <br>
    <p>ولی می دونم که مطالب سایتمون به دردت میخوره </p>
    <p>راستی میدونی بیمه به فکر آسایش و آرامش توست</p>
    <p> خوشحالیم که با ما لبخند می زنی</p>
    <a routerLink="/"><span class="arrow"></span> با کلیک به صفحه هشتگ بیمه بیا </a>
  </div>
</div>
</body>
</html>
